
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { FileText, Receipt, Calendar, Users, LogOut } from 'lucide-react';
import { useDashboard } from '@/hooks/useDashboard';
import { ITMGMTLogo } from '@/components/logo/ITMGMTLogo';

const BillingNavbar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { handleSignOut, userData } = useDashboard();

  const navItems = [
    { path: '/billing', label: 'Dashboard', icon: Calendar },
    { path: '/billing/estimates', label: 'Estimates', icon: FileText },
    { path: '/billing/invoices', label: 'Invoices', icon: Receipt },
    { path: '/billing/receipts', label: 'Receipts', icon: Receipt },
    { path: '/billing/contracts', label: 'Contracts', icon: Users }
  ];

  return (
    <div className="bg-white border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-8">
          <ITMGMTLogo />
          <h1 className="text-xl font-semibold text-itmgmt-dark-blue">Billing Portal</h1>
          
          <nav className="flex space-x-1">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              
              return (
                <Button
                  key={item.path}
                  variant={isActive ? "default" : "ghost"}
                  size="sm"
                  onClick={() => navigate(item.path)}
                  className="flex items-center space-x-2"
                >
                  <Icon className="h-4 w-4" />
                  <span>{item.label}</span>
                </Button>
              );
            })}
          </nav>
        </div>

        <div className="flex items-center space-x-4">
          <span className="text-sm text-gray-600">
            Welcome, {userData?.full_name || userData?.email}
          </span>
          <Button
            variant="outline"
            size="sm"
            onClick={handleSignOut}
            className="flex items-center space-x-2"
          >
            <LogOut className="h-4 w-4" />
            <span>Sign Out</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BillingNavbar;
